import {
  RosterProviderMatchStatus,
  type RosterNameMatch,
} from "@api/shared-runtime/roster-provider-match";

export const HIDDEN_MATCH_LABEL = "A provider outside your provider pools";

const STATUS_LABELS: Record<RosterProviderMatchStatus, string> = {
  [RosterProviderMatchStatus.Active]: "Active",
  [RosterProviderMatchStatus.Invited]: "Invited, pending acceptance",
  [RosterProviderMatchStatus.Ended]: "Ended",
  [RosterProviderMatchStatus.EndedByProvider]: "Left your organization",
};

export const getMatchStatusLabel = (status: RosterProviderMatchStatus) =>
  STATUS_LABELS[status];

export const getMatchName = (match: RosterNameMatch) => {
  if (!match.visible) {
    return HIDDEN_MATCH_LABEL;
  }
  return `${match.firstName ?? ""} ${match.lastName ?? ""}`.trim();
};
